module.exports = __webpack_public_path__ + "static/media/siteLock.b8140fba.svg";